package com.essntl.core.utils.viewmodel

sealed interface Operation<T> {
    data class Add<T>(val item: T) : Operation<T>

    data class Update<T>(val item: T) : Operation<T>

    data class Delete<T>(val item: T) : Operation<T>
}

val <T> Operation<T>.item: T
    get() =
        when (this) {
            is Operation.Add -> item
            is Operation.Update -> item
            is Operation.Delete -> item
        }
